import { Pipe, PipeTransform } from '@angular/core';
import { TicketStatus } from '../../model/index';


@Pipe({ name: 'ticketStatus' })
export class TicketStatusPipe implements PipeTransform {

    transform(value: TicketStatus): any {
        if (!value) {
            return '';
        }
        const style = this.getStyle(value);
        const iconColor = this.getIconColor(value);
        return `<div class="sm-status-badge" style="${style}">
                    <span class="material-symbols-outlined sm-status-badge-icon" style="color: ${iconColor}">square</span>     
                    ${(value as any).replaceAll(/_/g, " ")}
                </div>`;
    }

    private getStyle(value: TicketStatus): string {
        switch (value) {
            case TicketStatus.OPEN:
                return "color: #05387C;background-color: #0A70F826;";
            case TicketStatus.IN_PROGRESS:
                return "color: #746600;background-color: #E7CC0026;";
            case TicketStatus.ON_HOLD:
                return "color: #7B3E00;background-color: #F57B0026;";
            case TicketStatus.RESOLVED:
                return "color: #3D7300;background-color: #7AE50026;";
            case TicketStatus.REJECTED:
                return "color: #212121;background-color: #42424226;";
            default:
                return '';
        }
    }

    private getIconColor(value: TicketStatus): string {
        switch (value) {
            case TicketStatus.OPEN:
                return "#0A70F8";
            case TicketStatus.IN_PROGRESS:
                return "#E7CC00";
            case TicketStatus.ON_HOLD:
                return "#F57B00";
            case TicketStatus.RESOLVED:
                return "#7AE500";
            case TicketStatus.REJECTED:
                return "#424242";
            default:
                return '';
        }
    }
}